<app-eca-modal-host [heading]="modalHeading"
                    (saveClicked)="saveClicked()"
                    (cancelClicked)="cancelClicked()"
                    (editClicked)="editClicked()"
                    (helpClicked)="helpClicked()"
                    (saveAndUploadClicked)="saveAndUploadDocument()" [showSaveAndUploadButton]="showSaveAndUploadButton"
                    [yesButtonText]="yesButtonText" [yesButtonColour]="yesButtonColour"                    
                    [isEditing]="isEditing"
                    [yesButtonIcon]="['far', 'save']"
                    [noButtonIcon]="['far', 'times']"
                    [editButtonIcon]="['far', 'edit']"
                    noButtonColour="transparent">
  <div class="row" *ngIf="showingHelp">
    <div class="col">
      <app-eca-help-alert [helpHtmlText]="helpText"></app-eca-help-alert>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <app-observation-form [saveAttempted]="saveAttempted" [observation]="tempObservation" [isEditing]="isEditing"  > </app-observation-form>
    </div>
  </div>

</app-eca-modal-host>
